const translationsObj = {
  ar: {
    nav: {
      home: "الرئيسية",
      services: "خدماتنا",
      contact: "تواصل معنا",
      privacy: "سياسة الخصوصية",
      web: "تطبيقات الويب",
      mobile: "تطبيقات الجوال",
      desktop: "تطبيقات سطح المكتب",
      custom: "البرمجيات المخصصة",
    },
    hero: {
      badge: "موثوق به من عملاء دول الخليج والعالم",
      title: "نبني حلول",
      titleHighlight: "رقمية المستقبل",
      subtitle: "نصنع حلول برمجية متطورة للشركات في دول الخليج العربي وحول العالم. من الويب إلى الجوال، من سطح المكتب إلى البرمجيات المؤسسية المخصصة — نحول رؤيتك إلى واقع.",
      cta: "استكشف خدماتنا",
      ctaSecondary: "تواصل معنا",
      stats: {
        projects: "مشروع منجز",
        clients: "عميل سعيد",
        countries: "دولة نخدمها",
        experience: "سنوات خبرة",
      }
    },
    services: {
      title: "خدماتنا",
      subtitle: "حلول تطوير برمجيات شاملة مصممة لاحتياجات عملك",
      web: {
        title: "تطوير تطبيقات الويب",
        short: "تطبيقات الويب",
        desc: "تطبيقات ويب قابلة للتوسع وعالية الأداء مبنية بأحدث التقنيات. من التطبيقات أحادية الصفحة إلى بوابات الشركات.",
        features: ["React / Vue / Angular", "Node.js وAPIs السحابية", "منصات التجارة الإلكترونية", "بوابات المؤسسات", "تطبيقات الويب التقدمية"],
      },
      mobile: {
        title: "تطوير تطبيقات الجوال",
        short: "تطبيقات الجوال",
        desc: "تطبيقات جوال أصلية ومتعددة المنصات لـiOS وAndroid. تجربة مستخدم سلسة مع تكاملات خلفية قوية.",
        features: ["iOS وAndroid", "React Native / Flutter", "تصميم UI/UX", "نشر في المتاجر", "الإشعارات الفورية"],
      },
      desktop: {
        title: "تطوير تطبيقات سطح المكتب",
        short: "تطبيقات سطح المكتب",
        desc: "حلول سطح مكتب قوية لـWindows وmacOS وLinux. تطبيقات عالية الأداء لسير العمل التجاري المكثف.",
        features: ["Windows / macOS / Linux", "Electron و.NET", "العمل بدون إنترنت", "تكامل النظام", "التحديثات التلقائية"],
      },
      custom: {
        title: "حلول البرمجيات المخصصة",
        short: "البرمجيات المخصصة",
        desc: "برمجيات مصممة بدقة وفق متطلبات عملك. أنظمة ERP وCRM وسير عمل مخصصة تنمو مع نموك.",
        features: ["أنظمة ERP وCRM", "أتمتة الأعمال", "تحديث الأنظمة القديمة", "تكامل APIs", "تحليلات البيانات"],
      },
    },
    why: {
      title: "لماذا نيكساجين؟",
      subtitle: "نجمع التميز التقني مع الفهم العميق للأعمال",
      items: [
        { title: "خبرة خليجية", desc: "فهم عميق لثقافة الأعمال الخليجية واللوائح وديناميكيات السوق." },
        { title: "تسليم رشيق", desc: "تكرارات سريعة مع تواصل شفاف وتسليم في الوقت المحدد." },
        { title: "دعم على مدار الساعة", desc: "دعم وصيانة على مدار الساعة للحفاظ على أنظمتك تعمل." },
        { title: "معايير عالمية", desc: "معايير ترميز دولية مع حلول محلية لسوقك." },
      ]
    },
    process: {
      title: "عملية التطوير لدينا",
      steps: [
        { num: "01", title: "الاكتشاف", desc: "نحلل متطلباتك وأهداف عملك واحتياجاتك التقنية." },
        { num: "02", title: "التصميم", desc: "النماذج الأولية وتخطيط البنية لتجربة مستخدم مثالية." },
        { num: "03", title: "التطوير", desc: "سباقات رشيقة مع عروض منتظمة وتكامل مستمر." },
        { num: "04", title: "التسليم", desc: "الاختبار والنشر والدعم المستمر لحلك." },
      ]
    },
    cta: {
      title: "مستعد لبناء شيء رائع؟",
      subtitle: "دعنا نناقش مشروعك ونبتكر حلاً يدفع عملك إلى الأمام.",
      button: "ابدأ مشروعك",
    },
    contact: {
      title: "تواصل معنا",
      subtitle: "هل أنت مستعد لبدء مشروعك؟ يسعدنا سماعك.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      service: "الخدمة المطلوبة",
      message: "رسالتك",
      send: "إرسال الرسالة",
      info: {
        title: "معلومات الاتصال",
        address: "دبي، الإمارات العربية المتحدة",
        phone: "+971 4 XXX XXXX",
        email: "info@majtech.ae",
        hours: "الأحد - الخميس: 9:00 ص - 6:00 م بتوقيت الخليج",
      }
    },
    footer: {
      tagline: "نبني حلول رقمية لدول الخليج والعالم.",
      rights: "جميع الحقوق محفوظة.",
      links: "روابط سريعة",
      services: "الخدمات",
    }
  }
};

export {translationsObj}
